import { createActionGroup, props } from "@ngrx/store";
import { SubscriptionConcept } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export const DataSubscriptionConceptsActions = createActionGroup({
    source: "Data / Subscription Concepts",
    events: {
        "Load": props<{ companyId: string }>(),
        "Load Success": props<{ subscriptionConcepts: SubscriptionConcept[] }>(),
        "Load Failure": props<{ error: AppError; toastKey: string }>(),
    },
});
